import { useEffect, useRef } from "react";

export default function useTableResetState(reset = () => {}) {
    const resetRef = useRef(reset);
    resetRef.current = reset;

    useEffect(() => resetRef.current, []);
};
